import { render, staticRenderFns } from "./Gadget.vue?vue&type=template&id=3eac815b&"
import script from "./Gadget.vue?vue&type=script&lang=js&"
export * from "./Gadget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports